import React from 'react';

const TopBanner = () => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3">
      <div className="container mx-auto px-4 text-center flex flex-col md:flex-row items-center justify-center gap-4">
        <p className="text-sm md:text-base font-medium">
          Minden vállalkozás érjen célba, mert a web mindenkié
        </p>
        <a 
          href="https://digitalisvallalkozas.neum.hu/register/vallalkozas"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 px-4 py-1 rounded-full text-sm transition-all duration-300"
        >
          NEUM központi regisztráció
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default TopBanner; 